import * as Styled from './ReactionSummary.styles'
import {
  ThumbsUp,
  Heart,
  DownArrow,
  Laugh,
  OneHundred,
  Question,
  Fire,
  ThumbsUpMini,
  HeartMini,
  LaughMini,
  OneHundredMini,
  QuestionMini,
  FireMini,
} from '../../assets'

type ReactionsType = {
  [key: string]: number
}

type ReactionSummaryProps = {
  reactions: ReactionsType
  variant?: 'modal' | 'grid-view'
}

const ReactionSummary = ({
  reactions,
  variant = 'modal',
}: ReactionSummaryProps) => {
  const modalReactionIcons = [
    { name: 'Heart', icon: Heart },
    { name: 'Thumbs Up', icon: ThumbsUp },
    { name: 'Laugh', icon: Laugh },
    { name: 'Question', icon: Question },
    { name: 'Fire', icon: Fire },
    { name: 'One Hundred', icon: OneHundred },
  ]

  const gridviewReactionIcons = [
    { name: 'Heart', icon: HeartMini },
    { name: 'Thumbs Up', icon: ThumbsUpMini },
    { name: 'Laugh', icon: LaughMini },
    { name: 'Question', icon: QuestionMini },
    { name: 'Fire', icon: FireMini },
    { name: 'One Hundred', icon: OneHundredMini },
  ]

  const totalReactions = Object.values(reactions).reduce(
    (sum, count) => sum + count,
    0,
  )

  const selectedIconMap =
    variant === 'grid-view' ? gridviewReactionIcons : modalReactionIcons

  const selectedReactions = selectedIconMap.filter(
    (reaction) => reactions[reaction.name] > 0,
  )

  return variant === 'modal' ? (
    <Styled.Container>
      <Styled.ReactionStackContainer>
        {selectedReactions.length > 0 &&
          selectedReactions.map((reaction, index) => (
            <Styled.ReactionIcon
              key={index}
              src={reaction.icon}
              alt={reaction.name}
              index={index}
            />
          ))}
      </Styled.ReactionStackContainer>
      {selectedReactions.length > 0 && (
        <Styled.ReactionCountContainer>
          <Styled.ReactionCount>{totalReactions}</Styled.ReactionCount>
          <img src={DownArrow} alt="down arrow" />
        </Styled.ReactionCountContainer>
      )}
    </Styled.Container>
  ) : (
    <Styled.GridViewContainer>
      <Styled.GridReactionStack>
        {selectedReactions.map((reaction, index) => (
          <Styled.GridReactionItem key={index}>
            <img
              src={reaction.icon}
              alt={reaction.name}
              style={{ width: '20px', height: '20px' }}
            />
            <Styled.GridReactionCount>
              {reactions[reaction.name]}
            </Styled.GridReactionCount>
          </Styled.GridReactionItem>
        ))}
      </Styled.GridReactionStack>
    </Styled.GridViewContainer>
  )
}

export default ReactionSummary
